'use strict';

var AnalysisKpiRibbonReferenceAggregationFactory = function AnalysisKpiRibbonReferenceAggregationFactory(AbstractRomKpiRibbonAggregationFactory) {
  function AnalysisKpiRibbonReferenceAggregation() {
    AbstractRomKpiRibbonAggregationFactory.call(this, ['rom-analysis-skinny-services-reference-mode'], 'kpi-ribbon-reference');
  }
  AnalysisKpiRibbonReferenceAggregation.prototype = Object.create(AbstractRomKpiRibbonAggregationFactory.prototype);
  AnalysisKpiRibbonReferenceAggregation.constructor = AnalysisKpiRibbonReferenceAggregation;
  AnalysisKpiRibbonReferenceAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  AnalysisKpiRibbonReferenceAggregation.prototype.aggregate = function (data, metricsKeys) {
    var aggregatedData = {};
    if (data.length === 0) {
      return aggregatedData;
    }
    aggregatedData = this.iterate(data, metricsKeys, aggregatedData);
    return this.calcGap(aggregatedData, true);
  };
  return AnalysisKpiRibbonReferenceAggregation;
};
AnalysisKpiRibbonReferenceAggregationFactory.$inject = ['AbstractRomKpiRibbonAggregationFactory'];
module.exports = AnalysisKpiRibbonReferenceAggregationFactory;